module.exports = "<div class=\"image-placeholder\" ng-click=\"$ctrl.openMediaPicker()\">\n    <em class=\"fa fa-photo\" ></em>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/MediaModules/MediaPlaceholder/media-placeholder.html
// module id = 1151
// module chunks = 0